module.exports = __webpack_public_path__ + "bc2ad9600dae3e2b0f36d9b21d10d853.MP3";